(function () {

    "use strict";

    function masterDataService($translate) {

        var vm = this;

        vm.estados = [
            { value: 0, description: $translate.instant('ESTADOS.ABIERTA') },
            { value: 1, description: $translate.instant('ESTADOS.CANCELADA') },
            { value: 2, description: $translate.instant('ESTADOS.GANADA') },
            { value: 3, description: $translate.instant('ESTADOS.PERDIDA') }
        ];
    }

    masterDataService.$inject = ["$translate"];

    angular.module("sphforms.main").service("sphforms.masterDataService", masterDataService);

})();
